import { HtmlExpression } from "./html-expression.interface";
import { HtmlExpressionType } from "./html-expression-type.enum";


export class HtmlSequence implements HtmlExpression {
    public readonly type: HtmlExpressionType;

    public readonly children: HtmlExpression[];
    public readonly start: number;
    public readonly end: number;

    constructor(children: HtmlExpression[], start: number, end: number) {
        this.type = HtmlExpressionType.Sequence;
        this.children = children;
        this.start = start;
        this.end = end;
    }
}